import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const userApiService = createApi({
  reducerPath: 'userApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/user/'),
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (args) => {

        let { id } = args

        if (id) {
          return `get/${id}`
        }

        let params = queryParams(args)

        return `get${params}`
      },
      keepUnusedDataFor: 0
    }),
    getUserStats: builder.query({
      query: (args) => {
        let params = queryParams(args)
        return `stats${params}`
      },
      keepUnusedDataFor: 0
    }),
    createAdmin: builder.mutation({
      query: (args) => {
        return ({
          url: `create-admin`,
          method: 'POST',
          body: args
        })
      }
    }),
    updateUser: builder.mutation({
      query: (body) => {
        let url = body?._id ? `update/${body?._id}` : `update`

        delete body.email

        return ({
          url,
          method: 'PUT',
          body: body?.payload
        })

      }
    }),
    changePassword: builder.mutation({
      query: (args) => {

        return ({
          url: `change-password`,
          method: 'POST',
          body: args
        })

      }
    }),
    addUser: builder.mutation({
      query: (payload) => ({
        url: 'create',
        method: 'POST',
        body: payload
      })
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `delete/${id}`,
        method: 'DELETE'
      })
    }),
    assign: builder.mutation({
      query: (payload) => ({
        url: 'assign',
        method: 'PUT',
        body: payload
      })
    }),
    handleStatus: builder.mutation({
      query: (body) => ({
        url: `handle-status/${body.id}`,
        method: "PATCH",
        body: body?.payload
      })
    })
  })
})

export const {
  useGetUsersQuery,
  useGetUserStatsQuery,
  useCreateAdminMutation,
  useUpdateUserMutation,
  useChangePasswordMutation,
  useAddUserMutation,
  useAssignMutation,
  useDeleteUserMutation,
  useHandleStatusMutation
} = userApiService